function initSplitButtons() {
    let $splitButtons = $('.btn__split');

    $splitButtons.each(function () {
        let $split = $(this);

        if ($('.btn__split-label', this).length > 0) return false;

        $split.attr('data-label', $split.text());
        $split.wrapInner('<span class="btn__split-label"></span>');
    });
}

$('body').on('initScripts pageTransitionComplete buttonsUpdated', function() {
    initSplitButtons();
});
